import './src/vaadin-tabs.js';
export * from './src/vaadin-tabs.js';
